module.exports = __webpack_public_path__ + "fonts/Montserrat-MediumItalic.5ff27e6.ttf";